import { action } from "satcheljs";
import type { IContextualMenuItem } from "@fluentui/react/lib/ContextualMenu";

export interface LaunchAddinContextMenuActionMessage {
    contextMenuItems: IContextualMenuItem[];
    contextMenuHostId: string;
    tabId: string;
    hostItemIndex: string;
}
export const launchAddinContextMenu: (contextMenuItems: IContextualMenuItem[], contextMenuHostId: string, tabId: string, hostItemIndex: string) => LaunchAddinContextMenuActionMessage = action("launchAddinContextMenu", (contextMenuItems: IContextualMenuItem[], contextMenuHostId: string, tabId: string, hostItemIndex: string): LaunchAddinContextMenuActionMessage => ({
    contextMenuItems,
    contextMenuHostId,
    tabId,
    hostItemIndex,
}));
